/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/*!*****************************!*\
  !*** ./src/js/animation.js ***!
  \*****************************/


(function () {
  if (window.lightHouse) return;
  const LENIS_ENABLED = false;
  if (window.lenis && typeof window.lenis.destroy === "function") {
    window.lenis.destroy();
  }
  window.lenis = false;
  window.scroll = false;
  window.isSmooth = false;
  const body = document.body;
  const header = document.querySelector(".header");
  const headerToggle = document.querySelector(".header-toggle");
  const headerModal = document.querySelector(".header-modal");
  const headerOverflow = document.querySelector(".header-overflow");
  const headerHeight = header ? header.offsetHeight : 0;
  const inverseLerp = (a, b, value) => (value - a) / (b - a);
  const HEADER_SCROLL_DELTA = 10;
  let lastHeaderScroll = window.scrollY;
  let lastLenisScroll = window.scrollY;
  const isSafari = navigator.userAgent.indexOf("Safari") !== -1 && navigator.userAgent.indexOf("Chrome") === -1 && navigator.vendor && navigator.vendor.includes("Apple");
  const isHomePage = !!document.querySelector(".section.home");
  const isAboutPage = !!document.querySelector(".section.page-about");
  const isProductPage = !!document.querySelector(".section.product");
  const isCollectionPage = !!document.querySelector(".section.catalog");
  const isJournalPage = !!document.querySelector(".section.journal");
  function updateOnScroll(force = false, scrollY = window.scrollY, explicitDirection = 0) {
    const current = Math.max(0, Math.round(scrollY));
    const scrollDiff = current - lastHeaderScroll;
    const scrollingDown = explicitDirection ? explicitDirection > 0 : scrollDiff > 0;
    if (!force && Math.abs(scrollDiff) < HEADER_SCROLL_DELTA && current > headerHeight) {
      return;
    }

    // direction classes
    body.classList.toggle("scroll-down", scrollingDown);
    body.classList.toggle("scroll-up", !scrollingDown);

    // sticky
    if (header) {
      header.classList.toggle("sticky", current > 0);
    }

    // show / hide header
    if (header && headerModal && !headerModal.classList.contains("show")) {
      header.classList.toggle("show", force || !scrollingDown || current <= headerHeight);
    }
    lastHeaderScroll = current;
  }
  gsap.registerPlugin(DrawSVGPlugin, MotionPathPlugin, ScrollTrigger, ScrollToPlugin, SplitText);
  if (LENIS_ENABLED && window.matchMedia("(min-width: 1200px)").matches && !isSafari && !(isHomePage  || isJournalPage || isAboutPage || isProductPage || isCollectionPage)) {
    window.isSmooth = true;
    window.lenis = new Lenis({
      autoRaf: true
    });
    const scrollHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
    lenis.on("scroll", ({
      scroll,
      velocity,
      direction
    }) => {
      ScrollTrigger.update();
      const current = Math.round(scroll);
      if (current < 0 || scroll > scrollHeight) return;
      if (Math.abs(current - lastLenisScroll) < 1) return;
      const scrollDiff = current - lastLenisScroll;
      if (Math.abs(scrollDiff) > 15 || Math.abs(velocity) > 0.1) {
        updateOnScroll(false, current, direction);
      }
      lastLenisScroll = scroll;
    });

    // if (isHomePage || isAboutPage) {
    // 	lenis.options.lerp = 1;
    // 	lenis.options.duration = 0;
    // }
  }
  ScrollTrigger.config({
    limitCallbacks: true
  });
  ScrollTrigger.create({
    start: 0,
    end: "max",
    onUpdate: self => {
      updateOnScroll(false, self.scroll(), self.direction);
    }
  });
  updateOnScroll(true);

  // document.addEventListener('DOMContentLoaded', (event) => {
  /**
   * =========================
   * Init cloud animations
   * =========================
   */
  const sections = document.querySelectorAll(".section");
  const sections2 = document.querySelectorAll(".section.socials");
  const sections3 = document.querySelectorAll(".section.journal");
  const offset = window.innerWidth > 768 ? -window.innerHeight * 0.1 : -window.innerWidth * 0.1;
  const options = {
    force3D: true,
    snap: {
      y: 0.01
    }
  };
  sections?.forEach(section => {
    const cloud1 = section.querySelector(".section-cloud.cloud-1 img");
    const cloud2 = section.querySelector(".section-cloud.cloud-2 img");
    const cloud3 = section.querySelector(".section-cloud.cloud-3 img");
    gsap.matchMedia().add("(min-width: 1080px)", () => {
      if (cloud1) {
        gsap.to(cloud1, {
          y: offset,
          ...options,
          scrollTrigger: {
            trigger: section,
            start: "top bottom",
            end: "center center",
            scrub: 1.5
          }
        });
      }
      if (cloud2) {
        gsap.to(cloud2, {
          y: offset,
          scrollTrigger: {
            trigger: section,
            start: "top center",
            end: "center center",
            scrub: 1
          }
        });
      }
      if (cloud3) {
        gsap.fromTo(cloud3, {
          y: Math.abs(offset)
        }, {
          y: offset,
          ...options,
          scrollTrigger: {
            trigger: section,
            start: "bottom bottom",
            end: "bottom center",
            scrub: 1
          }
        });
      }
    });
  });
  sections2?.forEach(section => {
    const cloud1 = section.querySelector(".socials-cloud.cloud-1 img");
    const cloud2 = section.querySelector(".socials-cloud.cloud-2 img");
    gsap.matchMedia().add("(min-width: 1080px)", () => {
      if (cloud1) {
        gsap.fromTo(cloud1, {
          y: -offset
        }, {
          y: offset,
          ...options,
          scrollTrigger: {
            trigger: section,
            start: "top bottom",
            end: "center center",
            scrub: 1
          }
        });
      }
      if (cloud2) {
        gsap.fromTo(cloud2, {
          y: -offset
        }, {
          y: 0,
          scrollTrigger: {
            trigger: section,
            start: "top bottom",
            end: "center center",
            scrub: 1
          }
        });
      }
    });
  });
  sections3?.forEach(section => {
    const cloud1 = section.querySelector(".journal-cloud.cloud-1 img");
    const cloud2 = section.querySelector(".journal-cloud.cloud-2 img");
    gsap.matchMedia().add("(min-width: 1080px)", () => {
      if (cloud1) {
        gsap.fromTo(cloud1, {
          y: -offset
        }, {
          y: offset,
          ...options,
          scrollTrigger: {
            trigger: section,
            start: "top bottom",
            end: "center center",
            scrub: 1
          }
        });
      }
      if (cloud2) {
        gsap.fromTo(cloud2, {
          y: -offset
        }, {
          y: 0,
          scrollTrigger: {
            trigger: section,
            start: "top bottom",
            end: "center center",
            scrub: 1
          }
        });
      }
    });
  });

  /**
   * =========================
   * Init copy animations
   * =========================
   */
  const copyButtons = document.querySelectorAll(".copy-block");
  copyButtons?.forEach(button => {
    const text = button.dataset.copy;
    text && button.addEventListener("click", () => {
      navigator.clipboard.writeText(text).then(() => {
        button.classList.add("active");
      });
    });
  });

  /**
   * =========================
   * Init lottie animations
   * =========================
   */
  const LOTTIE_RENDERER = isAboutPage ? "svg" : isSafari ? "canvas" : "svg";
  const LOTTIE_DESTROY_DELAY = isSafari ? 350 : 180;
  if (isSafari && typeof lottie?.setQuality === "function") {
    lottie.setQuality("medium");
  }
  function destroyLottie(container) {
    if (container._lottieDestroyTimeout) {
      clearTimeout(container._lottieDestroyTimeout);
      container._lottieDestroyTimeout = null;
    }
    if (!container._lottie) return;
    container._lottie.destroy();
    container._lottie = null;
    container.innerHTML = "";
  }
  function initLottie(container) {
    if (container._lottieDestroyTimeout) {
      clearTimeout(container._lottieDestroyTimeout);
      container._lottieDestroyTimeout = null;
    }
    if (container._lottie) return;
    const isStop = container.classList.contains("js-lottie--stop");
    container._lottie = lottie.loadAnimation({
      container,
      renderer: LOTTIE_RENDERER,
      loop: true,
      autoplay: isStop ? false : true,
      path: container.dataset.src,
      animationSpeed: 0.5,
      rendererSettings: {
        progressiveLoad: true
      }
    });
    if (isStop && container._lottie) {
      container._lottie.goToAndStop(0, true);
    }
  }
  const lottieObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const container = entry.target;
      if (entry.isIntersecting) {
        if (container._lottieDestroyTimeout) {
          clearTimeout(container._lottieDestroyTimeout);
          container._lottieDestroyTimeout = null;
        }
        initLottie(container);
        if (container._lottie && !container.classList.contains("js-lottie--stop")) {
          container._lottie.play();
        }
        return;
      }
      if (container._lottieDestroyTimeout) return;
      container._lottieDestroyTimeout = setTimeout(() => {
        destroyLottie(container);
      }, LOTTIE_DESTROY_DELAY);
    });
  }, {
    rootMargin: "200px 0px",
    threshold: 0
  });
  document.querySelectorAll(".js-lottie").forEach(el => {
    lottieObserver.observe(el);
  });
  document.addEventListener("visibilitychange", () => {
    const isHidden = document.hidden;
    document.querySelectorAll(".js-lottie").forEach(el => {
      if (!el._lottie) return;
      if (isHidden) {
        el._lottie.pause();
        return;
      }
      if (!el.classList.contains("js-lottie--stop")) {
        el._lottie.play();
      }
    });
  });

  /**
   * =========================
   * SplitText creation: on demand from the observer below, plus a prewarm
   * that only runs in genuinely idle frames after load. The old eager pass
   * used requestIdleCallback with a 1s timeout, which forced heavy
   * split-and-measure work into the boot window (multi-second Style &
   * Layout tasks on throttled mobile).
   * =========================
   */
  function createSplit(el) {
    if (el._split) return;
    const type = el.dataset.split;
    switch (type) {
      case "headline":
        el._split = SplitText.create(el, {
          type: "lines, chars",
          linesClass: "line",
          charsClass: "char"
        });
        break;
      case "title":
        el._split = SplitText.create(el, {
          type: "lines, words, chars",
          linesClass: "line",
          wordsClass: "word",
          charsClass: "char"
        });
        break;
      case "text":
        el._split = SplitText.create(el, {
          type: "lines",
          linesClass: "line"
        });
        break;
      case "link":
        el._split = SplitText.create(el, {
          type: "chars",
          charsClass: "char"
        });
        break;
    }
  }
  window.addEventListener("load", () => {
    const elements = Array.from(document.querySelectorAll(".js-split"));
    let index = 0;
    function warmNext() {
      while (index < elements.length && elements[index]._split) index++;
      if (index >= elements.length) return;
      createSplit(elements[index++]);
      if ("requestIdleCallback" in window) {
        requestIdleCallback(warmNext);
      } else {
        setTimeout(warmNext, 200);
      }
    }
    if ("requestIdleCallback" in window) {
      requestIdleCallback(warmNext);
    } else {
      setTimeout(warmNext, 1000);
    }
  });

  /**
   * =========================
   * SplitText Observer Setup
   * =========================
   */
  const splitObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const el = entry.target;
      if (!el._split) createSplit(el);
      const type = el.dataset.split;
      switch (type) {
        case "headline":
          // initSplitHeadline(el);
          initSplitText(el);
          break;
        case "title":
          initSplitTitle(el);
          break;
        case "text":
          initSplitText(el);
          break;
        case "link":
          initSplitLink(el);
          break;
      }
      splitObserver.unobserve(el);
    });
  }, {
    rootMargin: "200px 0px",
    threshold: 0.05
  });
  document.querySelectorAll(".js-split").forEach(el => splitObserver.observe(el));

  /**
   * =========================
   * Init Functions
   * =========================
   */
  function initSplitHeadline(el) {
    if (!el._split || el._animated) return;
    el._animated = true;
    const split = el._split;
    const lines = [...split.lines];
    lines.forEach(line => {
      const chars = line.querySelectorAll(".char");
      const r = chars.length;
      gsap.set(chars, {
        opacity: 0
      });
      const initialStates = Array.from(chars).map((char, i) => {
        const pos = i < Math.ceil(r / 2) ? i : Math.ceil(r / 2) - Math.abs(Math.floor(r / 2) - i) - 1;
        return {
          scale: gsap.utils.mapRange(0, Math.ceil(r / 2), 0.5, 2.1, pos)
        };
      });
      gsap.fromTo(chars, {
        transformOrigin: "50% 100%",
        scale: i => initialStates[i].scale,
        opacity: 0
        // filter: 'blur(12px)'
      }, {
        ease: "power2.inOut",
        scale: 1,
        opacity: 1,
        // filter: 'blur(0px)',
        stagger: {
          amount: 0.15,
          from: "center"
        },
        scrollTrigger: {
          trigger: line,
          start: "top bottom",
          end: "center center",
          scrub: 0.5
          // onEnter: () => gsap.set(chars, { willChange: 'transform, filter' }),
          // onLeave: () => gsap.set(chars, { willChange: 'auto' }),
          // onEnterBack: () => gsap.set(chars, { willChange: 'transform, filter' }),
          // onLeaveBack: () => gsap.set(chars, { willChange: 'auto' })
        }
      });
    });
  }
  function initSplitTitle(el) {
    if (!el._split || el._animated) return;
    el._animated = true;
    const split = el._split;
    const lines = [...split.lines];
    lines.forEach((line, li) => {
      const chars = line.querySelectorAll(".char");
      const r = chars.length;
      if (!r) return;
      const initialY = Array.from(chars).map((char, i) => {
        const pos = i < Math.ceil(r / 2) ? i : Math.ceil(r / 2) - Math.abs(Math.floor(r / 2) - i) - 1;
        return 130 * (r / 2 - pos + 6);
      });
      gsap.fromTo(chars, {
        y: i => initialY[i]
      }, {
        ease: "elastic.out(.4)",
        y: 0,
        stagger: {
          amount: 0.1,
          from: "center"
        },
        snap: {
          y: 0.1
        },
        scrollTrigger: {
          trigger: line,
          start: "top bottom",
          once: true
          // end: "top 25%",
          // scrub: 0.5,
          // onEnter: () => gsap.set(chars, { willChange: 'transform' }),
          // onLeave: () => gsap.set(chars, { willChange: 'auto' }),
          // onEnterBack: () => gsap.set(chars, { willChange: 'transform' }),
          // onLeaveBack: () => gsap.set(chars, { willChange: 'auto' })
        }
      });
    });
  }
  function initSplitText(el) {
    if (!el._split || el._animated) return;
    el._animated = true;
    const split = el._split;
    const lines = [...split.lines];
    gsap.set(lines, {
      y: 30,
      opacity: 0
    });
    gsap.to(lines, {
      keyframes: [{
        y: -10,
        opacity: 0.7,
        duration: 0.6,
        ease: "power2.out"
      }, {
        y: 0,
        opacity: 1,
        duration: 0.3,
        ease: "power3.out"
      }],
      stagger: 0.05,
      scrollTrigger: {
        trigger: el,
        start: "top 75%",
        once: true
        // toggleActions: "play none none reverse",
        // onEnter: () => gsap.set(lines, { willChange: 'transform, opacity' }),
        // onLeave: () => gsap.set(lines, { willChange: 'auto' }),
        // onEnterBack: () => gsap.set(lines, { willChange: 'transform, opacity' }),
        // onLeaveBack: () => gsap.set(lines, { willChange: 'auto' })
      }
    });
  }
  function initSplitLink(el) {
    // if (!el._split || el._animated) return;
    // el._animated = true;

    // const split = el._split;

    el.addEventListener("mouseenter", () => {
      // if (!el._split || el._animated) return;
      // el._animated = true;

      if (!el._split) return;
      const split = el._split;
      const chars = split.chars;
      const duration = 0.6;
      const stagger = (1 - duration) / chars.length;
      gsap.to(chars, {
        duration,
        ease: "power2.inOut",
        stagger,
        overwrite: "auto",
        snap: {
          y: 0.1
        },
        keyframes: [{
          scaleY: 0.5,
          duration: duration / 2
        }, {
          scaleY: 1,
          duration: duration / 2
        }]
      });
    });
  }
  document.querySelectorAll(".marquee").forEach(container => {
    const track = container.querySelector(".marquee-inner");
    const originalItems = [...track.children];
    container.classList.add("is-marquee");
    track.innerHTML = "";
    originalItems.forEach(el => track.appendChild(el));
    const minWidth = Math.max(1440, window.innerWidth);
    const originalWidth = track.offsetWidth || 1;
    const copiesNeeded = Math.max(3, Math.ceil(minWidth / originalWidth) + 1);
    for (let i = 0; i < copiesNeeded; i++) {
      originalItems.forEach(el => track.appendChild(el.cloneNode(true)));
    }
    const isReversed = container.dataset.reversed === "true";
    const distance = originalWidth / 2;
    const speed = Math.abs(parseFloat(container.dataset.speed) || 20);
    const duration = distance / speed;
    gsap.set(track, {
      x: isReversed ? -originalWidth : 0
    });
    const tl = gsap.timeline({
      repeat: -1
    });
    tl.to(track, {
      x: isReversed ? 0 : -originalWidth,
      duration,
      ease: "none"
    });
    if (container.dataset.pauseOnHover === "true") {
      container.addEventListener("mouseenter", () => tl.pause());
      container.addEventListener("mouseleave", () => tl.resume());
    }
  });

  /**
   * =========================
   * Eye Tracking SVG
   * =========================
   */
  const svgObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      initEyeTracking(entry.target);
      // initBodyParallax(entry.target);
      svgObserver.unobserve(entry.target);
    });
  }, {
    threshold: 0.1
  });
  document.querySelectorAll(".js-teams-figures svg").forEach(svg => svgObserver.observe(svg));
  function initEyeTracking(svg) {
    const eyes = svg.querySelectorAll(".eye");
    if (!eyes.length) return;
    const EYE_TRACKING_FRAME = isSafari ? 1000 / 30 : 1000 / 60;
    const point = svg.createSVGPoint();
    const eyeData = [];
    function refreshEyeMetrics() {
      eyeData.length = 0;
      eyes.forEach(eye => {
        const sclera = eye.querySelector(".sclera");
        const pupil = eye.querySelector(".pupil");
        if (!sclera || !pupil) return;
        const sBox = sclera.getBBox();
        const pBox = pupil.getBBox();
        eyeData.push({
          pupil,
          cx: sBox.x + sBox.width / 2,
          cy: sBox.y + sBox.height / 2,
          maxX: (sBox.width - pBox.width) / 2,
          maxY: (sBox.height - pBox.height) / 2
        });
      });
    }
    refreshEyeMetrics();
    window.addEventListener("resize", refreshEyeMetrics, {
      passive: true
    });
    function getMousePosition(evt) {
      point.x = evt.clientX;
      point.y = evt.clientY;
      return point.matrixTransform(svg.getScreenCTM().inverse());
    }
    function updateEyePosition(e) {
      const mouse = getMousePosition(e);
      eyeData.forEach(eye => {
        let dx = mouse.x - eye.cx;
        let dy = mouse.y - eye.cy;
        const dist = Math.hypot(dx, dy) || 1;
        dx = dx / dist * Math.min(dist, eye.maxX);
        dy = dy / dist * Math.min(dist, eye.maxY);
        eye.pupil.setAttribute("transform", `translate(${dx.toFixed(2)} ${dy.toFixed(2)})`);
      });
    }
    let rafId = null;
    let isActive = false;
    let lastFrameTime = 0;
    function handleMouseMove(e) {
      if (!isActive || rafId) return;
      const now = performance.now();
      if (now - lastFrameTime < EYE_TRACKING_FRAME) return;
      rafId = requestAnimationFrame(() => {
        updateEyePosition(e);
        lastFrameTime = performance.now();
        rafId = null;
      });
    }
    const eyeObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        isActive = entry.isIntersecting;
        if (isActive) {
          document.addEventListener("mousemove", handleMouseMove);
        } else {
          document.removeEventListener("mousemove", handleMouseMove);
          eyes.forEach(eye => {
            const pupil = eye.querySelector(".pupil");
            if (pupil) pupil.removeAttribute("transform");
          });
        }
      });
    }, {
      threshold: 0,
      rootMargin: "50px"
    });
    eyeObserver.observe(svg);
  }
  function initBodyParallax(svg) {
    const bodies = svg.querySelectorAll(".body");
    if (!bodies.length) return;
    const speeds = [0.02, 0.035, 0.05, 0.025, 0.04, 0.03];
    const point = svg.createSVGPoint();
    function getMousePosition(evt) {
      point.x = evt.clientX;
      point.y = evt.clientY;
      return point.matrixTransform(svg.getScreenCTM().inverse());
    }
    function updateBodyPosition(e) {
      const mouse = getMousePosition(e);
      const centerX = window.innerWidth / 2;
      const centerY = window.innerHeight / 2;
      const deltaX = mouse.x - centerX;
      const deltaY = mouse.y - centerY;
      bodies.forEach((body, index) => {
        const speed = speeds[index] || 0.03;
        const x = deltaX * speed;
        const y = deltaY * speed;
        body.setAttribute("transform", `translate(${x.toFixed(2)} ${y.toFixed(2)})`);
      });
    }
    let rafId = null;
    let isActive = false;
    function handleMouseMove(e) {
      if (!isActive || rafId) return;
      rafId = requestAnimationFrame(() => {
        updateBodyPosition(e);
        rafId = null;
      });
    }
    const bodyObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        isActive = entry.isIntersecting;
        if (isActive) {
          document.addEventListener("mousemove", handleMouseMove);
        } else {
          document.removeEventListener("mousemove", handleMouseMove);
          bodies.forEach(body => {
            const pupil = body.querySelector(".pupil");
            if (pupil) pupil.removeAttribute("transform");
          });
        }
      });
    }, {
      threshold: 0,
      rootMargin: "50px"
    });
    bodyObserver.observe(svg);
  }
  const bubbles = document.querySelectorAll(".about-bubble");
  let mouseX = 0;
  let mouseY = 0;
  window.addEventListener("mousemove", e => {
    mouseX = (e.clientX / window.innerWidth - 0.5) * 40;
    mouseY = (e.clientY / window.innerHeight - 0.5) * 40;
  });
  bubbles.forEach((bubble, index) => {
    const depth = 50 + index * 30;
    const cursorStrength = 0.15 + index * 0.05;
    gsap.to(bubble, {
      y: -depth,
      ease: "none",
      scrollTrigger: {
        trigger: ".page-about",
        start: "top bottom",
        end: "bottom top",
        scrub: 1.2,
        invalidateOnRefresh: true
        // markers: true
      }
    });
    gsap.to(bubble, {
      x: () => mouseX * cursorStrength,
      y: () => bubble._gsap.y + mouseY * cursorStrength * 0.4,
      ease: "power3.out",
      duration: 0.6,
      overwrite: "auto"
    });
    gsap.ticker.add(() => {
      gsap.set(bubble, {
        x: mouseX * cursorStrength,
        y: bubble._gsap.y + mouseY * cursorStrength * 0.2
      });
    });
  });

  
  /**
   * =========================
   * Signature SVG Animation
   * =========================
   */
  document.querySelectorAll("svg.js-signature").forEach(svg => {
    const paths = svg.querySelectorAll("mask path");
    gsap.set(svg, {
      opacity: 0,
      visibility: "hidden"
    });
    gsap.set(paths, {
      drawSVG: "0% 0%"
    });
    let totalLength = 0;
    paths.forEach(p => {
      totalLength += p.getTotalLength();
    });
    const tl = gsap.timeline({
      paused: true,
      defaults: {
        ease: "none"
      }
    });
    tl.set(svg, {
      visibility: "visible",
      opacity: 1
    });
    const TOTAL_TIME = 2;
    paths.forEach(path => {
      const length = path.getTotalLength();
      const part = length / totalLength;
      tl.to(path, {
        drawSVG: "0% 100%",
        duration: TOTAL_TIME * part
      });
    });
    ScrollTrigger.create({
      trigger: svg,
      start: "top 90%",
      onEnter: () => tl.restart(),
      onLeaveBack: () => hideSignature(svg, paths, tl)
    });
    function hideSignature(svg, paths, tl) {
      gsap.to(svg, {
        opacity: 0,
        duration: 0.3,
        onComplete: () => {
          gsap.set(svg, {
            visibility: "hidden"
          });
          gsap.set(paths, {
            drawSVG: "0% 0%"
          });
          tl.pause(0);
        }
      });
    }
  });

  /**
   * =========================
   * Momentum-based Cards Hover
   * =========================
   */
  function initMomentumBasedCardsHover() {
    // If this device can’t hover with a fine pointer, stop here
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
      return;
    }

    // Configuration (tweak these for feel)
    const xyMultiplier = 30; // multiplies pointer velocity for x/y movement
    const rotationMultiplier = 20; // multiplies normalized torque for rotation speed
    const inertiaResistance = 200; // higher = stops sooner

    // Pre-build clamp functions for performance
    const clampXY = gsap.utils.clamp(-1080, 1080);
    const clampRot = gsap.utils.clamp(-60, 60);

    // Initialize each root container
    document.querySelectorAll("[data-inertia-init]").forEach(root => {
      let prevX = 0,
        prevY = 0;
      let velX = 0,
        velY = 0;
      let rafId = null;

      // Track pointer velocity (throttled to RAF)
      root.addEventListener("mousemove", e => {
        if (rafId) return;
        rafId = requestAnimationFrame(() => {
          velX = e.clientX - prevX;
          velY = e.clientY - prevY;
          prevX = e.clientX;
          prevY = e.clientY;
          rafId = null;
        });
      });

      // Attach hover inertia to each child element
      root.querySelectorAll("[data-inertia-element]").forEach(el => {
        el.addEventListener("mouseenter", e => {
          const target = el.querySelector("[data-inertia-child]");
          if (!target) return;

          // Compute offset from center to pointer
          const {
            left,
            top,
            width,
            height
          } = target.getBoundingClientRect();
          const centerX = left + width / 2;
          const centerY = top + height / 2;
          const offsetX = e.clientX - centerX;
          const offsetY = e.clientY - centerY;

          // Compute raw torque (px²/frame)
          const rawTorque = offsetX * velY - offsetY * velX;

          // Normalize torque so rotation ∝ pointer speed (deg/sec)
          const leverDist = Math.hypot(offsetX, offsetY) || 1;
          const angularForce = rawTorque / leverDist;

          // Calculate and clamp velocities
          const velocityX = clampXY(velX * xyMultiplier);
          const velocityY = clampXY(velY * xyMultiplier);
          const rotationVelocity = clampRot(angularForce * rotationMultiplier);

          // Apply GSAP inertia tween
          gsap.to(target, {
            inertia: {
              x: {
                velocity: velocityX,
                end: 0
              },
              y: {
                velocity: velocityY,
                end: 0
              },
              rotation: {
                velocity: rotationVelocity,
                end: 0
              },
              resistance: inertiaResistance
            }
          });
        });
      });
    });
  }
  initMomentumBasedCardsHover();

  /**
   * =========================
   * Toys animation
   * =========================
   */
  const toys = document.querySelector(".js-about-toys");
  function initToys() {
    if (window.matchMedia("(max-width: 1199px)").matches) return;
    const defaultToysElements = Array.from(toys.querySelectorAll(".about-toys__box"));
    const totalToys = 20;
    while (toys.querySelectorAll(".about-toys__box").length < totalToys) {
      defaultToysElements.forEach(el => {
        if (toys.querySelectorAll(".about-toys__box").length >= totalToys) return;
        toys.appendChild(el.cloneNode(true));
      });
    }
    const toysElements = toys.querySelectorAll(".about-toys__box");
    const direction = document.documentElement.getAttribute("dir") || getComputedStyle(document.documentElement).direction;
    const isRTL = direction === "rtl";
    const multiplier = isRTL ? -1 : 1;
    const containerWidth = toys.offsetWidth;
    const containerHeight = toys.offsetHeight;
    const positions = [];
    for (let i = 0; i < toysElements.length; i++) {
      positions.push(i / (toysElements.length - 1) * containerWidth);
    }
    positions.sort(() => Math.random() - 0.5);
    toysElements.forEach((el, i) => {
      gsap.set(el, {
        x: (positions[i] - containerWidth / 2) * multiplier,
        y: 0,
        rotation: gsap.utils.random(-45, 45),
        opacity: 1,
        transformOrigin: "center center"
      });
    });
    gsap.to(toysElements, {
      keyframes: [{
        opacity: 1,
        duration: 5,
        ease: "power2.out"
      }, {
        opacity: 0,
        duration: 1,
        ease: "power3.out"
      }],
      y: containerHeight,
      duration: 6,
      // opacity: 0,
      ease: "power2.out",
      stagger: {
        each: 0.1,
        from: "random"
      },
      scrollTrigger: {
        trigger: toys,
        start: "top 30%",
        toggleActions: "play none none none"
      }
    });
  }
  if (toys) initToys();

  // const header = document.querySelector('.header');
  const productGallery = document.querySelector(".product-gallery");
  const productInner = document.querySelector(".product-inner");
  if (productGallery && productInner) {
    // gsap.matchMedia().add("(min-width: 1200px)", () => {
    // 	const st = ScrollTrigger.create({
    // 		trigger: productInner,
    // 		pin: productGallery,
    // 		start: "top top",
    // 		end: "bottom bottom",
    // 		// end: () =>
    // 		// 	`top+=${productInner.offsetHeight - productGallery.offsetHeight} top`,
    // 		// pinSpacing: false,
    // 		invalidateOnRefresh: true,
    // 		// markers: true
    // 	});
    // 	// const accordionButtons = productInner.querySelectorAll(
    // 	// 	".js-product-accordion",
    // 	// );
    // 	// accordionButtons.forEach((btn) => {
    // 	// 	btn.addEventListener("click", () => {
    // 	// 		setTimeout(() => {
    // 	// 			st.refresh();
    // 	// 		}, 600);
    // 	// 	});
    // 	// });
    // });
  }
  function storyTitle() {
    document.fonts.ready.then(function () {
      gsap.matchMedia().add("(min-width: 1200px)", () => {
        $(".story").each(function () {
          const $container = $(this);
          const lottie1 = $container[0].querySelector(".story-figure.figure-1.js-lottie");
          const lottie2 = $container[0].querySelector(".story-figure.figure-2.js-lottie");
          const lottie3 = $container[0].querySelector(".story-figure.figure-3.js-lottie");
          const lottie4 = $container[0].querySelector(".story-figure.figure-4.js-lottie");
          const lt1_point = 0.4;
          const lt2_point = 0.7;
          const lt3_point = 1.0;

          // split the heading into characters
          var $headline = $container.find(".title .h0");
          if ($headline.length) {
            SplitText.create($headline[0], {
              type: "chars",
              charsClass: "char"
            });
          }
          var $title = $container.find(".title");
          var $subtitle = $container.find(".subtitle");
          var $chars = $container.find(".char");

          // if the main text element isn't found, skip this container
          if (!$title.length) {
            console.warn("storyTitle: .title element not found in one of the containers");
            return;
          }

          // calculate how far the text needs to move (fallback to 0 if undefined)
          var textWidth = $title[0].clientWidth || 0;
          var bodyWidth = document.body.clientWidth || 0;
          var distance = textWidth - bodyWidth;
          var offset = textWidth * 1.1;
          var scrollTween = gsap.to($title, {
            x: -offset,
            ease: "none",
            scrollTrigger: {
              trigger: $container[0],
              start: "center center",
              // end: '125% bottom',
              end: `+=${window.innerWidth * 2}`,
              pin: $container[0],
              anticipatePin: 1,
              scrub: 0.5,
              onUpdate: self => {
                // lottie1
                if (self.progress <= lt1_point) lottie1.classList.remove("hide");
                if (self.progress > lt1_point) lottie1.classList.add("hide");

                // lottie2
                if (self.progress > lt1_point && self.progress <= lt2_point) lottie2.classList.remove("hide");
                if (self.progress <= lt1_point || self.progress > lt2_point) lottie2.classList.add("hide");

                // lottie3 + lottie4
                if (self.progress > lt2_point) {
                  lottie3.classList.remove("hide");
                  lottie4.classList.remove("hide");
                }
                if (self.progress <= lt2_point) {
                  lottie3.classList.add("hide");
                  lottie4.classList.add("hide");
                }
                if (lottie1 && lottie1._lottie && self.progress <= lt1_point) {
                  const progress = inverseLerp(0, lt1_point, self.progress);
                  const frame = Math.floor(progress * lottie1._lottie.totalFrames - 1);
                  lottie1._lottie.goToAndStop(Math.max(frame, 0), true);
                }
                if (lottie2 && lottie2._lottie && self.progress > lt1_point && self.progress <= lt2_point) {
                  const progress = inverseLerp(lt1_point, lt2_point, self.progress);
                  const frame = Math.floor(progress * (lottie2._lottie.totalFrames - 1));
                  lottie2._lottie.goToAndStop(Math.max(frame, 0), true);
                }
                if (lottie3 && lottie3._lottie && self.progress > lt2_point) {
                  const progress = inverseLerp(lt2_point, lt3_point, self.progress);
                  const frame = Math.floor(progress * (lottie3._lottie.totalFrames - 1));
                  lottie3._lottie.goToAndStop(Math.max(frame, 0), true);
                }
                if (lottie4 && lottie4._lottie && self.progress > lt2_point) {
                  const progress = inverseLerp(lt2_point, lt3_point, self.progress);
                  const frame = Math.floor(progress * (lottie4._lottie.totalFrames - 1));
                  lottie4._lottie.goToAndStop(Math.max(frame, 0), true);
                }
              }
            }
          });
          gsap.to($subtitle, {
            x: -$subtitle[0].clientWidth * 2,
            ease: "none",
            force3D: true,
            scrollTrigger: {
              trigger: $container[0],
              start: "center center",
              end: `+=${window.innerWidth * 0.5}`,
              scrub: 0.5
            }
          });
          $chars.each(function () {
            gsap.from(this, {
              yPercent: (Math.random() - 0.5) * 500,
              rotation: (Math.random() - 0.5) * 60,
              ease: "elastic.out(1.2, 1)",
              scrollTrigger: {
                trigger: this,
                containerAnimation: scrollTween,
                start: "left 90%",
                end: "left 10%",
                scrub: 0.5
              }
            });
          });
        });
      });
      gsap.matchMedia().add("(max-width: 1199px)", () => {
        $(".story").each(function () {
          const $container = $(this);
          const lottie1 = $container[0].querySelector(".story-figure.figure-1.js-lottie");
          const lottie2 = $container[0].querySelector(".story-figure.figure-2.js-lottie");
          ScrollTrigger.create({
            trigger: lottie1,
            endTrigger: $container[0],
            start: "top bottom",
            end: "bottom center",
            scrub: 0.5,
            onUpdate: self => {
              const progress = inverseLerp(0, 1, self.progress);
              if (lottie1 && lottie1._lottie) {
                const frame = Math.floor(progress * lottie1._lottie.totalFrames - 1);
                lottie1._lottie.goToAndStop(Math.max(frame, 0), true);
              }
              if (lottie2 && lottie2._lottie) {
                const frame = Math.floor(progress * (lottie2._lottie.totalFrames - 1));
                lottie2._lottie.goToAndStop(Math.max(frame, 0), true);
              }
            }
          });
        });
      });
    });
  }
  storyTitle();
  const aboutImages = document.querySelectorAll(".page-about .about-figure");
  if (aboutImages && aboutImages.length) {
    const screen = document.querySelector(".about-first-screen");
    const mm = gsap.matchMedia();
    let scrollTimeout;
    mm.add("(min-width: 768px)", () => {
      window.addEventListener("scroll", () => {
        if (window.scrollY > 0) {
          aboutImages?.forEach(image => {
            image.classList.add("hide");
            image._lottie?.pause();
          });
          return;
        }
        aboutImages?.forEach(image => {
          image.classList.remove("hide");
          image._lottie?.play();
        });
      });
    });
    mm.add("(max-width: 767px)", () => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: screen,
          start: "bottom bottom",
          // end: "+=160px",
          end: "bottom 50%",
          scrub: 1,
          onUpdate: self => {
            if (self.progress > 0.6) {
              aboutImages?.forEach(image => {
                image.classList.add("hide");
                image._lottie?.pause();
              });
            } else {
              aboutImages?.forEach(image => {
                image.classList.remove("hide");
                image._lottie?.play();
              });
            }
          }
        }
      });
      aboutImages?.forEach(image => {
        const x = image.classList.contains("figure-1") ? -50 : 50;
        tl.to(image, {
          x: `${x}%`
        }, 0);
      });
    });
  }

  // const socialSection = document.querySelector('.section.socials .socials-list');

  // if (socialSection) {
  // 	const socials = socialSection.querySelectorAll('.socials-box');
  // 	const circles = socialSection.querySelectorAll('.socials-box picture');
  // 	const bgs = socialSection.querySelectorAll('.socials-box__bg');

  // 	const tl = gsap.timeline({
  // 		scrollTrigger: {
  // 			trigger: socialSection,
  // 			start: 'top bottom',
  // 			end: 'center center',
  // 			scrub: 1
  // 		}
  // 	});

  // 	gsap.set(bgs, { scale: 0, force3D: true })
  // 	gsap.set(circles, { rotate: 180, force3D: true})

  // 	tl.to(bgs, { scale: 1 })
  // 	tl.to(circles, { rotate: 0 }, 0)
  // }
  // });

  // ScrollTrigger.config({
  //   limitCallbacks: true,
  //   syncInterval: 16
  // });
})();
/******/ })()
;